import { validationStateMixin } from './';

export const baseValidatableMixin = {
    mixins: [validationStateMixin],
    props: {
        /**
         * Indicates if labelshould be displayed.
         * _(base property)_
         */
        noLabel: {
            type: Boolean,
            defaultValue: false
        },
        /**
         * Form field name shown left to the form input. 
         * If not specified, no text will be shown.
         * _(base property)_
         */
        label: {
            type: String,
            default: null
        },
        /**
         * Additional form field name that is used for validation provider. 
         * Is used in case when field name in validation error message is different than provided `label`,
         * or `label` is not specified, but field name should be displayed in the validation error message. 
         * _(base property)_
         */
        fieldName: {
            type: String,
            default: null
        },
        /**
         * Validation rules. Are applied if `validatable = true`.
         * _(base property)_
         */
        rules: {
            type: Object | String,
            default: () => ({ required: true })
        },
        /**
         * `<ValidationObserver />` property.
         * If provided it will be used as the observer's id when being registered as a child of a parent observer
         * _(base property)_
         */
        vid: {
            type: String,
            default: null
        },
        /**
         * Show `*` sign in the end of the field name.
         * _(base property)_
         */
        asterix: {
            type: Boolean,
            default: false
        },
        /**
         * `<b-form-group />` property. 
         * Defines width of label columns starting from `sm` size.
         * Can be set to '0' to make form field full width.
         * _(base property)_
         */
        labelColsSm: {
            type: String,
            default: '6'
        },
        /**
         * `<b-form-group />` property. 
         * Defines css class added to field label.
         * _(base property)_
         */
        labelClass: {
            type: String,
            default: ''
        },
        /**
         * `<b-form-group />` property. 
         * Defines css class added to fieldset (entire form field label+input).
         * _(base property)_
         */
        controlClass: {
            type: String,
            default: 'no-delimiter mb-1 pb-1'
        },
        /**
         * Placeholder for form input field.
         * _(base property)_
         */
        placeholder: {
            type: String,
            default: null
        },
        /**
         * Defines if field is validatable according to `rules`.
         * _(base property)_
         */
        validatable: {
            type: Boolean,
            default: false
        },
        /**
         * Value of the form field.
         * _(base property)_
         */
        value: null,
        /**
         * Indicates if value should be emited on nextTick.  
         * May be useful in modals.
         * _(base property)_
         */
        nextTick: {
            type: Boolean,
            default: false,
        },
        /**
         * Text to show in the inform icon.
         * _(base property)_
         */
        helpDescription: {
            type: String,
            defaultValue: null,
        },
    },
    computed: {
        fieldLabel() {
            return this.label + (this.asterix ? ' *' : '');
        }
    },
    methods: {
        getValidationClass(validatable, { dirty, validated, valid = null }) {
            if (!validatable) {
                return '';
            }
            if (dirty || validated) {
                return valid ? 'is-valid' : 'is-invalid';
            }
            return '';
        },
        processInput($event) {
            return $event;
        },
        emitValue($event) {
            var processedValue = this.processInput($event);
            if (this.nextTick) {
                this.$nextTick(() => {
                    this.$emit("input", processedValue);
                });
            } else {
                this.$emit("input", processedValue);
            }
        }
    }
};